module.exports = __webpack_public_path__ + "static/media/ic_more_info.356ad43c.svg";